const STALE_DYNAMIC_IMPORT_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
];

const getReloadStorageKey = (key) => `dynamic-import-reload:${key}`;

const getErrorMessage = (error) => {
  if (!error) {
    return "";
  }

  if (typeof error === "string") {
    return error;
  }

  return `${error.message ?? ""} ${error.name ?? ""}`.trim();
};

const isStaleDynamicImportError = (error) => {
  const message = getErrorMessage(error);

  return STALE_DYNAMIC_IMPORT_PATTERNS.some((pattern) => pattern.test(message));
};

const importWithReload = (importer, key) =>
  new Promise((resolve, reject) => {
    const storageKey = getReloadStorageKey(key);
    const hasReloaded = window.sessionStorage.getItem(storageKey) === "true";

    importer()
      .then((module) => {
        window.sessionStorage.removeItem(storageKey);
        resolve(module);
      })
      .catch((error) => {
        if (!isStaleDynamicImportError(error)) {
          reject(error);
          return;
        }

        if (hasReloaded) {
          reject(error);
          return;
        }

        window.sessionStorage.setItem(storageKey, "true");
        window.location.reload();
      });
  });

export const lazyWithReload = (importer, key) =>
  importWithReload(importer, key);

export const routeLazyWithReload = (importer, key) =>
  importWithReload(importer, key);
